"use client";

import React from "react";
import { cn } from "@/utils/utils";

import Website from "@/common/constants/webstite";

import LinkElement from "@/components/LinkElement";
import { ChevronLeftIcon } from "@/components/icons";
import useTranslationApi from "@/lib/hooks/useTranslationApi";

export default function NBackLink({
  collectionTitle = "Quay lại nmagazine",
  translateKeyButton = "back_to_nmagazine",
  className,
}: {
  collectionTitle?: string;
  translateKeyButton?: string;
  className?: string;
}) {
  const { t } = useTranslationApi([translateKeyButton]);
  return (
    <>
      <LinkElement
        href={Website.LINK.PAGE.NMAGAZINE}
        className={cn(
          "w-fit text-base font-bold hidden md:flex items-center gap-1 mt-6 mb-4 group h-[24px]",
          className
        )}
      >
        <ChevronLeftIcon className="w-[24px] h-[24px] min-w-[24px] group-hover:text-red-500 group-focus:text-red-500 transition-all" />
        <p className="group-hover:text-red-500 group-focus:text-red-500 transition-all">
          {/* Quay lại nmagazine */}
          {t(translateKeyButton)}
        </p>
      </LinkElement>
      <div
        className={cn(
          "text-base font-bold flex md:hidden items-center justify-center mt-6 mb-4 w-full relative h-[24px]",
          className
        )}
      >
        <p className="uppercase absolute top-0 left-0 bottom-0 right-0 w-full text-center max-w-[300px] truncate mx-auto">
          {collectionTitle}
        </p>
        <LinkElement href={Website.LINK.PAGE.NMAGAZINE}>
          <ChevronLeftIcon className="w-[24px] h-[24px] min-w-[24px] absolute top-0 left-0 bottom-0" />
        </LinkElement>
      </div>
    </>
  );
}
